import FiltrosJuicios from '../../moleculas/FiltrosJuicios/FiltrosJuicios'

function FiltrosJuiciosContainer() {
  return (
    <div className="flex flex-row justify-between m-3">
      <FiltrosJuicios/>
  </div>
  )
}

export default FiltrosJuiciosContainer